// extracted by mini-css-extract-plugin
module.exports = {"dialogRoot":"RestrictedPageDialog_dialogRoot__4HdAz","container":"RestrictedPageDialog_container__96In4","crossIcon":"RestrictedPageDialog_crossIcon__aZmK9"};